import { cn } from "../../utils/cn";
import type { TaskStepInstance } from "../../../api/tasks";

type TaskStepBadgeProps = {
  step: TaskStepInstance;
};

export function TaskStepBadge({ step }: TaskStepBadgeProps) {
  const statusColors = {
    pending: "bg-muted text-muted-foreground",
    active: "bg-primary text-primary-foreground",
    completed: "bg-success text-success-foreground",
    skipped: "bg-muted text-muted-foreground",
  };

  return (
    <div
      className={cn(
        "w-12 h-12 rounded-full flex items-center justify-center font-semibold text-sm",
        statusColors[step.status] || statusColors.pending
      )}
    >
      {step.order_index}
    </div>
  );
}
